import factorial from './factorial';
export default function nCr(n, r) {
    let answer = 1;
    for (let i = 0; i < r; i++) {
        answer *= (n - i);
    }
    return answer / factorial(r);
}
